import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { demandeService, filialeService } from '../services/api';

import MenuProfil from '../components/MenuProfil';
import {
  IconePlume,
} from '../components/IconesSVG';

export default function PDGDashboardPage() {
  const navigate = useNavigate();
  
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [periode, setPeriode] = useState('mois');

  // eslint-disable-next-line react-hooks/exhaustive-deps -- effet volontairement limite au montage
  useEffect(() => { charger(); }, []);

  const charger = async () => {
    try {
      setLoading(true);
      const [demandesRes, filialesRes] = await Promise.all([
        demandeService.getAll({ limit: 500 }),
        filialeService.getAll()
      ]);
      const data = demandesRes.data || [];
      calculerStats(data, filialesRes.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const calculerStats = (data, filialesList) => {
    const maintenant = new Date();
    const debutMois = new Date(maintenant.getFullYear(), maintenant.getMonth(), 1);

    const ceMois = data.filter(d => new Date(d.createdAt) >= debutMois);
    const approuves = data.filter(d => d.statut === 'approuve');
    const enAttente = data.filter(d => d.statut === 'en_attente_pdg');
    const aRegulariser = data.filter(d => d.statut === 'a_regulariser');
    const rejetes = data.filter(d => d.statut === 'rejete');

    const montantTotal = approuves.reduce((s, d) => s + (d.montantEstime || 0), 0);
    const montantAttente = enAttente.reduce((s, d) => s + (d.montantEstime || 0), 0);
    const montantMois = ceMois.reduce((s, d) => s + (d.montantEstime || 0), 0);

    // Stats par filiale
    const parFiliale = filialesList.map(f => {
      const docs = data.filter(d => d.filiale?._id === f._id || d.filiale === f._id);
      const approuvesF = docs.filter(d => d.statut === 'approuve');
      const attenteF = docs.filter(d => ['soumis','en_validation_acheteur','en_validation_direction','en_validation_memo_filiale','en_validation_dg_filiale','en_validation_memo_holding','en_attente_pdg'].includes(d.statut));
      return {
        filiale: f,
        total: docs.length,
        approuves: approuvesF.length,
        enAttente: attenteF.length,
        montant: approuvesF.reduce((s, d) => s + (d.montantEstime || 0), 0),
        taux: docs.length > 0 ? Math.round((approuvesF.length / docs.length) * 100) : 0
      };
    }).sort((a, b) => b.total - a.total);

    // Derniers 6 mois
    const parMois = [];
    for (let i = 5; i >= 0; i--) {
      const d = new Date();
      d.setMonth(d.getMonth() - i);
      const moisData = data.filter(doc => {
        const docDate = new Date(doc.createdAt);
        return docDate.getMonth() === d.getMonth() && docDate.getFullYear() === d.getFullYear();
      });
      parMois.push({
        label: d.toLocaleDateString('fr-FR', { month: 'short' }),
        count: moisData.length,
        montant: moisData.reduce((s, doc) => s + (doc.montantEstime || 0), 0)
      });
    }

    setStats({
      total: data.length,
      ceMois: ceMois.length,
      approuves: approuves.length,
      enAttente: enAttente.length,
      aRegulariser: aRegulariser.length,
      rejetes: rejetes.length,
      montantTotal,
      montantAttente,
      montantMois,
      parFiliale,
      parMois,
      tauxApprobation: data.length > 0 ? Math.round((approuves.length / data.length) * 100) : 0
    });
  };

  const formatMontant = (m) => {
    if (!m) return '0';
    if (m >= 1000000) return (m / 1000000).toFixed(1) + 'M';
    if (m >= 1000) return (m / 1000).toFixed(0) + 'K';
    return m.toLocaleString('fr-FR');
  };

  const maxMois = stats?.parMois ? Math.max(...stats.parMois.map(m => m.count), 1) : 1;
  const maxMontantMois = stats?.parMois ? Math.max(...stats.parMois.map(m => m.montant), 1) : 1;

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0D1B2A', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 16 }}>
      Chargement des statistiques...
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#F5F6FA', fontFamily: 'Inter, system-ui, sans-serif' }}>
      {/* TOPBAR */}
      <div style={{ background: '#0D1B2A', padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, background: '#C0392B', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src="/logo.png" alt="JETA" style={{ height: 22 }} onError={e => { e.target.style.display = 'none'; }} />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}>Tableau de bord — Directeur General</div>
            <div style={{ fontSize: 11, color: '#8899AA' }}>Vue consolidee · Toutes filiales</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => navigate('/parapheur')}
            style={{ padding: '7px 14px', borderRadius: 8, border: '0.5px solid rgba(255,255,255,0.2)', background: 'transparent', color: '#fff', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: 6 }}>
            <IconePlume taille={14} /> Parapheur ({stats?.enAttente || 0})
          </button>
          <MenuProfil couleurAvatar="#C0392B" />
        </div>
      </div>

      <div style={{ padding: '24px' }}>
        {/* KPI CARDS */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 24 }}>
          {[
            { label: 'Total documents', value: stats?.total, sub: 'Toutes filiales', color: '#0D1B2A', bg: '#fff' },
            { label: 'A signer', value: stats?.enAttente, sub: formatMontant(stats?.montantAttente) + ' FCFA en attente', color: '#C0392B', bg: '#FDEDEC', onClick: () => navigate('/parapheur') },
            { label: 'Approuves', value: stats?.approuves, sub: formatMontant(stats?.montantTotal) + ' FCFA signe', color: '#1E8449', bg: '#EAFAF1' },
            { label: 'Taux approbation', value: stats?.tauxApprobation + '%', sub: stats?.rejetes + ' rejetes', color: '#1A5E8A', bg: '#EAF4FB' },
          ].map((kpi, i) => (
            <div key={i} onClick={kpi.onClick}
              style={{ background: kpi.bg, borderRadius: 12, padding: '16px 18px', border: '0.5px solid #e5e7eb', cursor: kpi.onClick ? 'pointer' : 'default', transition: '0.15s' }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>{kpi.label}</div>
              <div style={{ fontSize: 28, fontWeight: 500, color: kpi.color, marginBottom: 4 }}>{kpi.value}</div>
              <div style={{ fontSize: 11, color: '#888' }}>{kpi.sub}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
          {/* GRAPHE MENSUEL */}
          <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', border: '0.5px solid #e5e7eb' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: '#0D1B2A' }}>Evolution mensuelle</div>
              <div style={{ display: 'flex', gap: 6 }}>
                {['count', 'montant'].map(v => (
                  <button key={v} onClick={() => setPeriode(v)}
                    style={{ padding: '4px 10px', borderRadius: 20, border: 'none', fontSize: 11, cursor: 'pointer', fontFamily: 'inherit', background: periode === v ? '#0D1B2A' : '#F5F6FA', color: periode === v ? '#fff' : '#666' }}>
                    {v === 'count' ? 'Nombre' : 'Montants'}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, height: 120 }}>
              {stats?.parMois?.map((m, i) => {
                const val = periode === 'count' ? m.count : m.montant;
                const max = periode === 'count' ? maxMois : maxMontantMois;
                const hauteur = max > 0 ? Math.max((val / max) * 100, 4) : 4;
                return (
                  <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                    <div style={{ fontSize: 10, color: '#888' }}>
                      {periode === 'count' ? val : formatMontant(val)}
                    </div>
                    <div style={{ width: '100%', height: hauteur + '%', background: i === 5 ? '#C0392B' : '#0D1B2A', borderRadius: '4px 4px 0 0', minHeight: 4, transition: '0.3s' }} />
                    <div style={{ fontSize: 10, color: '#888' }}>{m.label}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* STATS RAPIDES */}
          <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', border: '0.5px solid #e5e7eb' }}>
            <div style={{ fontSize: 14, fontWeight: 500, color: '#0D1B2A', marginBottom: 16 }}>Resume financier</div>
            {[
              { label: 'Montant signe total', value: formatMontant(stats?.montantTotal) + ' FCFA', color: '#1E8449', bg: '#EAFAF1' },
              { label: 'En attente signature', value: formatMontant(stats?.montantAttente) + ' FCFA', color: '#C0392B', bg: '#FDEDEC' },
              { label: 'Ce mois', value: formatMontant(stats?.montantMois) + ' FCFA', color: '#1A5E8A', bg: '#EAF4FB' },
              { label: 'A regulariser', value: stats?.aRegulariser + ' dossier(s)', color: '#935116', bg: '#FDF2E9' },
            ].map((row, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: 8, background: row.bg, marginBottom: 8 }}>
                <span style={{ fontSize: 12, color: '#555' }}>{row.label}</span>
                <span style={{ fontSize: 13, fontWeight: 500, color: row.color }}>{row.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* PAR FILIALE */}
        <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', border: '0.5px solid #e5e7eb' }}>
          <div style={{ fontSize: 14, fontWeight: 500, color: '#0D1B2A', marginBottom: 16 }}>
            Performance par filiale
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                {['Filiale', 'Total docs', 'Approuves', 'En attente', 'Montant signe', 'Taux', 'Progression'].map(h => (
                  <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontSize: 11, fontWeight: 500, color: '#888', background: '#F9FAFB', borderBottom: '0.5px solid #e5e7eb' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {stats?.parFiliale?.filter(f => f.total > 0).map((f, i) => (
                <tr key={i} style={{ borderBottom: '0.5px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 12px', verticalAlign: 'middle' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div style={{ width: 28, height: 28, borderRadius: 6, background: '#0D1B2A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 500, color: '#fff', flexShrink: 0 }}>
                        {f.filiale.code}
                      </div>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#0D1B2A' }}>{f.filiale.nom}</div>
                    </div>
                  </td>
                  <td style={{ padding: '12px 12px', color: '#0D1B2A', fontWeight: 500 }}>{f.total}</td>
                  <td style={{ padding: '12px 12px' }}>
                    <span style={{ color: '#1E8449', fontWeight: 500 }}>{f.approuves}</span>
                  </td>
                  <td style={{ padding: '12px 12px' }}>
                    {f.enAttente > 0
                      ? <span style={{ background: '#FDEDEC', color: '#96281B', padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 500 }}>{f.enAttente}</span>
                      : <span style={{ color: '#aaa' }}>0</span>
                    }
                  </td>
                  <td style={{ padding: '12px 12px', color: '#C0392B', fontWeight: 500 }}>
                    {formatMontant(f.montant)} FCFA
                  </td>
                  <td style={{ padding: '12px 12px', fontWeight: 500, color: f.taux >= 70 ? '#1E8449' : f.taux >= 40 ? '#935116' : '#C0392B' }}>
                    {f.taux}%
                  </td>
                  <td style={{ padding: '12px 12px' }}>
                    <div style={{ width: '100%', height: 6, background: '#f0f0f0', borderRadius: 3, overflow: 'hidden' }}>
                      <div style={{ width: f.taux + '%', height: '100%', background: f.taux >= 70 ? '#27AE60' : f.taux >= 40 ? '#E67E22' : '#C0392B', borderRadius: 3, transition: '0.5s' }} />
                    </div>
                  </td>
                </tr>
              ))}
              {stats?.parFiliale?.filter(f => f.total === 0).length > 0 && (
                <tr>
                  <td colSpan={7} style={{ padding: '10px 12px', color: '#aaa', fontSize: 12, textAlign: 'center' }}>
                    {stats.parFiliale.filter(f => f.total === 0).length} filiale(s) sans activite ce mois
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
